



























































































































































































































































































































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'

//@ts-ignore
import pmd_arboles_problema from '@/mixins/axios/pmd_arboles_problema'

//@ts-ignore
import pmd_arboles_objetivos from '@/mixins/axios/pmd_arboles_objetivos'


//@ts-ignore
import dependencias from '@/mixins/axios/general_secretarias'

//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'
//@ts-ignore
import axios from "axios";


//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
 import OrganizationChart from 'vue-organization-chart'
  import 'vue-organization-chart/dist/orgchart.css'
import VueHtml2pdf from 'vue-html2pdf'

@Component({
  components: {
   OrganizationChart,VueHtml2pdf
  },

  data() {

    return {
        
        idmir:null,
        render_all:true,
        createMirv1:false,
        objetivos:[],
        mir_data:{
            causas_n:null
        },
          fullcard:false,
        type:'Creacion',
        problema_select:{
            problema:''
        },
        dependencias:[],
        departamentos:[],
problema:'',
        iddepartamento:0,
        idsecretaria:0,
        identificador:null,
        id:null,

        saveeditefecto:{
    data:{text:'',objetivo:''},
type:null,
i1:0
},
saveeditcausa:{
    data:{text:''},
type:null,
i1:0,
i2:0,
i3:0
},

        causas_n:[],
        efectos_n1:[
           
            
        ],
         efectos_n2:[
            
           
        ],
         efectos_n3:[
          
           
        ],
        checked:{
            e1:[],
            e2:[],
            e3:[]
        }
        
    }
   
  },
  mixins:[pmd_arboles_problema,departamentos,dependencias,pmd_arboles_objetivos],
  methods:{ 
      async onClick() {
       var sTable = document.getElementById('tablaobjetivo').innerHTML;
              await axios({
                    url: this.$store.state.baseapi+"pdf",
                    method: 'POST',
                    data:{
                      html:sTable,
                      title:"Arbol de Objetivos",
                      id:this.$store.state.user.usuario.id_municipio
                    },
                    headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
                    responseType: 'blob'
                }).then((response) => {
                     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                     var fileLink = document.createElement('a');

                     fileLink.href = fileURL;
                     fileLink.setAttribute('download', 'file.pdf');
                     document.body.appendChild(fileLink);

                     fileLink.click();
                });
          },
async imprimir(){
    this.$router.push('/mun/poa/imprimirObje')
},
      async eliminar(){
          
         let data6={
id:this.$store.state.arbol_problema.idobjetivos,

};

         this.show=false;
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_PMDS_ARBOLES_OBJETIVOS(data6).then(response => {

                    if (response != null) {
 this.show=false;
 
 this.show=true;
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
     confirm(){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar();
    },function(){ 
      
        
    });
     },

      generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },

    createPDF() {
        var sTable = document.getElementById('contpdf').innerHTML;

        var style = "<style>";
        style = style + "table {width: 100%;font: 17px Calibri;}";
        style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
        style = style + "padding: 2px 3px;text-align: center;}";
        style = style + "</style>";

        // CREATE A WINDOW OBJECT.
        var win = window.open('', '', 'height=700,width=700');

        win.document.write('<html><head>');
        win.document.write('<title>Profile</title>');   // <title> FOR PDF HEADER.
        win.document.write(style);          // ADD STYLE INSIDE THE HEAD TAG.
        win.document.write('</head>');
        win.document.write('<body>');
        win.document.write(sTable);         // THE TABLE CONTENTS INSIDE THE BODY TAG.
        win.document.write('</body></html>');

        win.document.close(); 	// CLOSE THE CURRENT WINDOW.

        win.print();    // PRINT THE CONTENTS.
    },



      McreateMirv1(){
console.log(this.mir_data.causas_n)
this.mir_data.causas_n=this.causas_n;

console.log(this.mir_data.causas_n)

this.createMirv1=true;
      },
onChange(event){
//console.log(event.target.value)
this.getDataDepartamentos(event.target.value);
},

VerMir1(){
  
var row=[];
let mir_data=this.mir_data;
/*
for (const element of this.mir_data.causas_n) {
      row[element]=mir_data.causas_n[element];
    
    row[element].childs=[];
     elemento=element;

     for (const element2 of element.childs) {
          //this.mir_data.causas_n[element].childs[element2]=row[element].childs[element2];
        row[elemento].childs[element2]=mir_data.causas_n[elemento].childs[element2];
        
        
     }
    
    
}*/
 for (let element = 0; element < mir_data.causas_n.length; element++) {


        if(mir_data.causas_n[element].hasOwnProperty('check')){

                row[element]=mir_data.causas_n[element];
            var childs= row[element].childs;
            row[element].indicador=0;
            row[element].medios="";
            row[element].supuesto="";
            row[element].childs=[];
            //console.log(element)
            //console.log(mir_data.causas_n[element])

                for (let element2 = 0; element2 < childs.length; element2++) {
                    if(childs[element2].hasOwnProperty('check')){
                        //console.log(element2)
                        row[element].childs[element2]=childs[element2];
                        row[element].childs[element2].indicador=0;
            row[element].childs[element2].medios="";
            row[element].childs[element2].supuesto="";
                        var childs2= row[element].childs[element2].childs;
                    row[element].childs[element2].childs=[];
                     for (let element3 = 0; element3 < childs2.length; element3++) {
                          if(childs2[element3].hasOwnProperty('check')){
                        //console.log(element2)
                        //console.log('------child3')
                        //console.log(element3)
                        //console.log(childs2[element3])
                        // console.log('------child3 --end')
                        row[element].childs[element2].childs[element3]=childs2[element3];
                        row[element].childs[element2].childs[element3].indicador=0;
                        row[element].childs[element2].childs[element3].medios="";
            row[element].childs[element2].childs[element3].supuesto="";
                        //var childs2= row[element].childs;
                    //row[element].childs[element2].childs=[];
                          }
                        
                    }

                    }
                    
                }
        }

     }
console.log('-ini row');
console.log(row);
console.log('-fin row');

let data={
    idmir:this.idmir,
    fin:{
        fin:this.efectos_n3[0].objetivo,
        supuesto:"",
        indicador:0,
        medios:""},
    objetivo:{
        objetivo:this.problema,
        supuesto:"",
        indicador:0,
        medios:""
        },
    data:row,

    }
    if(this.idmir==null||this.idmir==0){
        data.idmir=null;
      this.$store.commit('SETMIR',data);
this.$router.push('/mun/pmd/mirbuilderv1?type=crear')
}else{

let data={
    idmir:this.idmir
    }
       this.$store.commit('SETMIR',data);
this.$router.push('/mun/pmd/mirbuilderv1?type=editar')
}

},
vermirId(){

let data={
    idmir:this.idmir
    }
       this.$store.commit('SETMIR',data);
this.$router.push('/mun/pmd/mirbuilderv1?type=editar')
},
VerMir2(){
    let row={
id:this.$store.state.arbol_problema.idobjetivos

}

      this.$store.commit('SETOBJETIVO',row);
this.$router.push('/mun/pmd/mirbuilder?type=crear')

},

async getObjetivo() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
id:this.$store.state.arbol_problema.idobjetivos,

};

let data= await this.GET_PMDID_ARBOLES_OBJETIVOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                       //this.problema_select=response; 
                       this.id=response.id;
                       this.efectos_n1=JSON.parse(response.fines)[0];
                       this.efectos_n2=JSON.parse(response.fines)[1];
                       this.efectos_n3=JSON.parse(response.fines)[2];
                        this.causas_n=JSON.parse(response.componentes);
                         this.problema=response.objetivo;
                         this.idmir=response.idmir;
//console.log(response)
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

async getPeoblema() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
id:this.$store.state.arbol_problema.id,

};

let data= await this.GET_PMDID_ARBOLES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                       this.problema_select=response; 
                       this.efectos_n1=JSON.parse(response.efectos)[0];
                       this.efectos_n2=JSON.parse(response.efectos)[1];
                       this.efectos_n3=JSON.parse(response.efectos)[2];
                        this.causas_n=JSON.parse(response.causas);
                         //this.problema=response.problema;
//console.log(response)
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
async getDataDepartamentos(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
iddependencia:id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_GENERAL_DEPARTAMENTOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.departamentos=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async getDataSecretarias() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_SECRETARIAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.dependencias=response;
this.getDataDepartamentos(response[0].id);
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

     async create(){
//alert(this.type)
         if('edit'==this.$route.query.type){
             let dat={
                 id:this.$store.state.arbol_problema.idobjetivos,
idarbol_problema:this.$store.state.arbol_problema.id,
           
             objetivo:this.problema, 
              fin:[this.efectos_n1,this.efectos_n2,this.efectos_n3], 
               componentes:this.causas_n
         };
           
          
          let data= await this.EDITAR_PMD_ARBOLES_OBJETIVOS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;

this.$router.push('/mun/poa/arbol')

                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Árbol de Objetivos, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });
return;
         }else{
             
         

         let dat={
idarbol_problema:this.$store.state.arbol_problema.id,
           
             objetivo:this.problema, 
              fin:[this.efectos_n1,this.efectos_n2,this.efectos_n3], 
               componentes:this.causas_n
         };
           
          
          let data= await this.CREAR_PMD_ARBOLES_OBJETIVOS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;

this.$router.push('/mun/poa/arbol')

                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Árbol de Objetivos, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });
                }

      },
//pmd_arboles_problema
      
      add_i(type,index:0,index2:0){
switch (type) {
    case 'n1':
        this.efectos_n1.push({text:'efecto'})
        break;
         case 'n2':
         this.efectos_n2.push({text:'efecto'})
        break;
         case 'n3':
         this.efectos_n3.push({text:'efecto'})
        break;
          case 'c1':
         this.causas_n.push({text:'causa',childs:[]})
        break;
         case 'child_causa':
         this.causas_n[index].childs.push({text:'causa',childs:[]})
        break;
         case 'child_child_causa':
         this.causas_n[index].childs[index2].childs.push({text:'causa'})
        break;

    default:
        break;
}
      },
      editefectosave(){

let i1=this.saveeditefecto.i1;
            switch (this.saveeditefecto.type) {
              case 'e1':
              this.efectos_n1[i1]=this.saveeditefecto.data;
            
                  
                  break;
                  case 'e2':
                   this.efectos_n2[i1]=this.saveeditefecto.data;
                  break;
                  case 'e3':
                   this.efectos_n3[i1]=this.saveeditefecto.data;
            
                  break;
          
              default:
                  break;
          }
          this.saveeditefecto.data={text:'',objetivo:''};
          $('#modalEfecto').modal('hide');
      },
      editcausasave(){

let i1=this.saveeditcausa.i1;
let i2=this.saveeditcausa.i2;
let i3=this.saveeditcausa.i3;
            switch (this.saveeditcausa.type) {
              case 'c1':
              this.causas_n[i1]=this.saveeditcausa.data;
            
                  
                  break;
                  case 'c2':
                   this.causas_n[i1].childs[i2]=this.saveeditcausa.data;
                  break;
                  case 'c3':
                   this.causas_n[i1].childs[i2].childs[i3]=this.saveeditcausa.data;
            
                  break;
          
              default:
                  break;
          }
          this.saveeditcausa.data={text:'',objetivo:''};
          $('#modalCausa').modal('hide');
      },
      editefecto(type,data:any,i1:0){
this.saveeditefecto.data=data;
           this.saveeditefecto.type=type;
           this.saveeditefecto.i1=i1;
 
          $('#modalEfecto').modal('show');
      },
      editcausa(type,data:any,i1:0,i2:0,i3:0){

           this.saveeditcausa.data=data;
           this.saveeditcausa.type=type;
           this.saveeditcausa.i1=i1;
           this.saveeditcausa.i2=i2;
           this.saveeditcausa.i3=i3;
 
          $('#modalCausa').modal('show');
      },
      setActive(type,row:any,i1:0,i2:0,i3:0){
          console.log(type);
          console.log(this.mir_data.causas_n[i1])
             console.log('index')
           console.log(i3)
           console.log(i1)
             console.log('index')
             this.render_all=false;
          switch (type) {
              
              case 'c1':
              if(this.mir_data.causas_n[i1].hasOwnProperty('check')){
delete this.mir_data.causas_n[i1].check;
              }else{
this.mir_data.causas_n[i1].check=true;
              }
              
             // this.causas_n=  this.causas_n.slice(0, i1).concat(this.causas_n.slice(i1+1, this.causas_n.length))
           
                  
                  break;
                  case 'c2':
                   if(this.mir_data.causas_n[i1].childs[i2].hasOwnProperty('check')){
delete this.mir_data.causas_n[i1].childs[i2].check;
              }else{
this.mir_data.causas_n[i1].childs[i2].check=true;
              }
               
                   //this.causas_n[i1].childs=  this.causas_n[i1].childs.slice(0, i2).concat(this.causas_n[i1].childs.slice(i2+1, this.causas_n[i1].childs.length))
            
                  break;
                  case 'c3':
                  if(this.mir_data.causas_n[i1].childs[i2].childs[i3].hasOwnProperty('check')){
delete this.mir_data.causas_n[i1].childs[i2].childs[i3].check;
              }else{
this.mir_data.causas_n[i1].childs[i2].childs[i3].check=true;
              }
                   //this.causas_n[i1].childs[i2].childs=  this.causas_n[i1].childs[i2].childs.slice(0, i3).concat(this.causas_n[i1].childs[i2].childs.slice(i3+1, this.causas_n[i1].childs[i2].childs.length))
            
                  break;
          
              default:
                  break;
          }
          this.render_all=true;
      },
          delete_causa(type,i1:0,i2:0,i3:0){
          switch (type) {
              case 'c1':
              this.causas_n=  this.causas_n.slice(0, i1).concat(this.causas_n.slice(i1+1, this.causas_n.length))
            
                  
                  break;
                  case 'c2':
                   this.causas_n[i1].childs=  this.causas_n[i1].childs.slice(0, i2).concat(this.causas_n[i1].childs.slice(i2+1, this.causas_n[i1].childs.length))
            
                  break;
                  case 'c3':
                   this.causas_n[i1].childs[i2].childs=  this.causas_n[i1].childs[i2].childs.slice(0, i3).concat(this.causas_n[i1].childs[i2].childs.slice(i3+1, this.causas_n[i1].childs[i2].childs.length))
            
                  break;
          
              default:
                  break;
          }
      },
      delete_efecto(nivel,i){
          console.log(nivel)
           console.log(i)
          if(nivel=='n1'){
              console.log('n1--')
            this.efectos_n1=  this.efectos_n1.slice(0, i).concat(this.efectos_n1.slice(i+1, this.efectos_n1.length))
            console.log( this.efectos_n1)
            if(this.efectos_n1.length<=0){
                this.efectos_n2=[];
                 this.efectos_n3=[];

            }
          }
          if(nivel=='n2'){
               console.log('n2--')
            this.efectos_n2=  this.efectos_n2.slice(0, i).concat(this.efectos_n2.slice(i+1, this.efectos_n2.length))
            if(this.efectos_n2.length<=0){
               
                 this.efectos_n3=[];

            }
          }
          if(nivel=='n3'){
               console.log('n3--')
            this.efectos_n3=  this.efectos_n3.slice(0, i).concat(this.efectos_n3.slice(i+1, this.efectos_n3.length))
          }

      },
      validacion()
      {

          //
      },
      add(data){
$('#modalCausa').modal('show')
          switch (data.type) {
              case 1:
                  //alert('causa');
                  break;
                   case 2:
                //  alert('hijo efecto');
                  break;
                   case 3:
                  
//alert('hijo causa');
                  break;
                   case 4:
                  
                  break;
          
              default:
                  break;
          }






      },
      hola(data){
console.log(data);
      }
   
  },
  created(){
      
  },
  mounted(){

      if(this.$route.query.type=='edit'){
          this.type='Edicion';
//this.getPeoblema();
this.getObjetivo();
      }else{
           this.type='Creacion';
this.getPeoblema();
      }
   
   
  }
})
export default class Home extends Vue {}

